import { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { NUMBER_FORMAT_LOCALE_OPTIONS, NumberFormatLocale } from '../../../../utils/numberFormat';

interface NumberFormatLocaleFieldProps {
  value?: NumberFormatLocale;
  onChange: (value: NumberFormatLocale) => void;
}

export const NumberFormatLocaleField: FC<NumberFormatLocaleFieldProps> = ({ value = 'DE', onChange }) => (
  <FormControl fullWidth size="small">
    <InputLabel id="number-format-locale-label">Number formatting</InputLabel>
    <Select
      labelId="number-format-locale-label"
      label="Number formatting"
      value={value}
      onChange={(e) => onChange(e.target.value as NumberFormatLocale)}
    >
      {NUMBER_FORMAT_LOCALE_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
